export default {
  title: 'Dashboard',
  description: 'Who is on each site right now.',
  descriptionLive: 'Who is on each site right now. Counts refresh automatically.',
  noActiveSites: 'No active sites yet',
  noSitesAssigned: 'No sites assigned',
  noActiveSitesMessage: 'Create your first site with a geofence. Paired phones start reporting presence as soon as it is active.',
  noSitesAssignedMessage: 'Your account has no sites assigned yet. Ask your administrator to add you to one.',
  newSite: 'New site',
  onSiteNow: 'On site now',
  personAcrossSites: 'person across all sites',
  peopleAcrossSites: 'people across all sites',
  waitingForReading: 'Waiting for the first reading',
  activeSites: 'Active sites',
  reportingPresence: 'Reporting presence',
  busiestSite: 'Busiest site',
  noAddress: 'No address',
  couldntLoad: "Couldn't load",
  onSite: 'on site',
  refreshing: 'Refreshing…',
  rosteredNowSuffix: ' · {count} rostered now',
  onSiteRostered: 'on site · {count} rostered',
  notOnSite: 'Not on site: {names}',
  attentionTitle: 'Needs your attention',
  allClear: 'All clear. Nothing is waiting on you.',
  couldntCheck: "Couldn't check {checks}.",
  checkAttendance: 'attendance',
  checkSwaps: 'swaps',
  checkLeave: 'leave',
  checkOpenSpots: 'open spots',
  checkJobs: 'jobs',
  checkTimesheets: 'timesheets',
  checkAssets: 'assets',
  checkEmployees: 'employees',
  namesTwo: '{a} and {b}',
  namesMoreOne: '{names} and {count} other',
  namesMoreOther: '{names} and {count} others',
  noShowOne: 'No-show on shift now',
  noShowOther: 'No-shows on shift now',
  declinedJobOne: 'Job with declined crew',
  declinedJobOther: 'Jobs with declined crew',
  swapOne: 'Shift swap to approve',
  swapOther: 'Shift swaps to approve',
  leaveOne: 'Leave request waiting',
  leaveOther: 'Leave requests waiting',
  claimOne: 'Open-spot claim to review',
  claimOther: 'Open-spot claims to review',
  timesheetOne: "Last week's timesheet to approve",
  timesheetOther: "Last week's timesheets to approve",
  assetOne: 'Asset due for renewal or service',
  assetOther: 'Assets due for renewal or service',
  assetDetail: 'Rego, insurance, warranty or maintenance',
  phoneOne: 'Phone with location or notifications off',
  phoneOther: 'Phones with location or notifications off',
  quietOnSiteOne: 'Person on site, not heard from in over an hour',
  quietOnSiteOther: 'People on site, not heard from in over an hour',
  appRemovedOne: 'Phone with the app removed',
  appRemovedOther: 'Phones with the app removed',
  inviteOne: 'Invite expired before pairing',
  inviteOther: 'Invites expired before pairing',
  todayTitle: 'Today',
  startingSoon: 'Starting soon',
  startingSoonHint: 'Next 3 hours',
  startingSoonEmpty: 'Nobody starts in the next 3 hours.',
  jobsTitle: 'Jobs',
  jobsEmpty: 'No jobs today.',
  jobCrew: '{site} · {count} crew',
  jobCrewOpen: '{site} · {count} crew · {open} open',
  awayTitle: 'Away',
  awayEmpty: 'Nobody is on leave or unavailable.',
  unavailableWindow: 'Unavailable {window}',
  moreRows: '+{count} more',
}
